// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { PrimaryTemplate } from 'components/templates/PrimaryTemplate';
import { useTranslation } from 'react-i18next';
import { Path } from 'routes';
import CollectQRScanning from 'components/organisms/CollectQRScanning';
import queryString from 'query-string';
import { useUpdateQuery } from 'util/queryParams';

const CollectQRScan = () => {
  const { t } = useTranslation();
  const siteId = queryString.parse(window.location.search).siteId;
  const updateQueryParams = useUpdateQuery();

  return (
    <PrimaryTemplate
      h1={t('collects.title')}
      prevFunction={() => {
        updateQueryParams({
          callback: (searchParams) => {
            searchParams.delete('siteId');
          },
          pathname: Path.collects,
        });
      }}
    >
      <CollectQRScanning siteId={siteId} />
    </PrimaryTemplate>
  );
};

export default CollectQRScan;
